export default "__VITE_ASSET__BHZziJiu__"